<div class="widget-container" data-cy="top-widget-panel">
	<div
		(click)="onWidgetClick('unclaimed')"
		[class.active]="activeWidget === 'unclaimed'"
		class="widget-item unclaimed cursor-pointer"
	>
		<span>Unclaimed</span>

		<div data-cy="unclaimed-badge" class="badge">
			{{ unclaimedCount }}
		</div>
	</div>

	<div
		(click)="onWidgetClick('followups')"
		[class.active]="activeWidget === 'followups'"
		class="widget-item follow-ups cursor-pointer"
	>
		<span>Follow Ups</span>

		<div data-cy="follow-ups-badge" class="badge">
			{{ followUpCount }}
		</div>
	</div>

	<div
		(click)="onWidgetClick('mentions')"
		[class.active]="activeWidget === 'mentions'"
		class="widget-item mentions cursor-pointer"
	>
		<span>Mentions</span>

		<div data-cy="mentions-badge" class="badge">
			{{ mentionCount }}
		</div>
	</div>

	<div
		(click)="onWidgetClick('outstanding')"
		[class.active]="activeWidget === 'outstanding'"
		class="widget-item outstanding cursor-pointer"
	>
		<span>Outstanding</span>

		<div data-cy="outstanding-badge" class="badge">
			{{ outstandingCount }}
		</div>
	</div>
</div>
